module.exports = {
  // 菜单栏Class
  menuClass: {
    enterprise: '企业账户总览',
    personal: '个人账户总览'
  },
  // 登录注册Class
  loginClass: {
    userLogin: '用户端登录界面',
    account: '请输入手机号/邮箱',
    password: '请输入密码',
    login: '登录',
    registerTips: '欢迎注册云钱账号',
    realName: '真实姓名',
    mobile: '手机号',
    verificationCode: '验证码',
    submit: '发送',
    agreeTips: '我已阅读并同意',
    agreementTips: '《云钱账户注册协议》',
    register: '注册',
    registerTime: '注册时间',
    registerDone: '注册成功',
    tel: '手机号'
  },
  // 企业账户&&个人账户Class
  accountClass: {
    accountRelated: '账户相关',
    corporateAccounts: '企业账户总览',
    accountManagement: '企业关联账号管理',
    accountOverview: '个人账户总览',
    overviewManagement: '账户管理总览',
    cloudPoint: '云积分账户',
    TEUCurrency: 'Tue币',
    recharge: '充值',
    membership: '购买会员',
    details: '交易明细',
    membershipPeriod: '会员有效期',
    benefitsAvailable: '可享受权益',
    welcome: '欢迎',
    userID: '用户ID',
    accountID: '账户ID',
    exit: '退出',
    personal: '个人',
    personalDetails: '个人交易明细',
    enterpriseDetails: '企业交易明细',
    tips: '请输入被添加用户ID，若被添加人未注册，请先让其注册',
    personalAccountID: '个人账户 ID',
    companyAccountID: '公司账户 ID',
    inputAccountName: '请输入账户ID',
    transferAccounts: '转账',
    confirmTransfer: '确认转账'
  },
  // 企业交易明细&&个人交易明细Class
  tradingClass: {
    startDate: '开始时间',
    endDate: '结束时间',
    transactionDate: '交易日期',
    tradeSources: '交易来源',
    transactionType: '交易类型',
    all: '全部',
    consumption: '消费',
    reconciliation: '调账',
    transactionGifts: '交易赠送',
    membershipRecharge: '入会充值',
    confirmMembership: '确认会员',
    confirmRecharge: '确认支付',
    cloudBl: '云单',
    cloudBooking: '云舱',
    cloudExhibition: '云展',
    cloudMondy: '云钱',
    mall: '商城',
    transactionTime: '交易时间',
    trader: '交易人',
    accountName: '账户名',
    transactionNo: '交易编号',
    transactionAmount: '交易金额',
    pointBalance: '积分账户余额',
    amountPay: '实付金额（人民币）',
    note: '备注',
    download: '表格下载',
    query: '查询',
    account: '账户',
    queryOptions: '查询选项',
    allForms: '全部表单',
    selectStartTime: '点击选择开始时间',
    selctEndTime: '点击选择结束时间',
    inputTransactionNo: '请输入交易编号',
    selectTradeSources: '请选择交易来源',
    selectTransactionType: '请选择交易类型',
    startTime: '请选择开始时间',
    endTime: '请选择结束时间',
    invalidFormat: '交易编号的格式不正确',
    deleteSuccessful: '删除成功！',
    deleteFailed: '删除失败！',
    inputId: '请输入账户ID',
    permissionstoast: '请选择角色权限',
    addSuccess: '添加成功',
    modifySuccess: '修改成功',
    balance: '余额',
    transfer: '转账',
    transferAmount: '转账金额',
    inputTransferAmount: '请输入转账金额'
  },
  checkClass: {
    accountTips: '请输入账户ID',
    permissions: '请选择权限'
  },
  // 会员Class
  membersClass: {
    membersTips1: '需缴纳',
    membersTips2: '元会员费',
    bronzeMember: '青铜会员',
    goldMember: '黄金会员',
    platinumMember: '白金会员',
    benefitsAvailable: '可享受权益',
    paymentChecking: '您已缴费，等待平台人工复核确认中',
    membershipDetails: '详情',
    bemembers: '成为会员，享受更多权益！',
    nonmembbers: '非会员暂无权益',
    validity: '会员有效期',
    equity: '可享受权益',
    review: '您已缴费，等待平台人工复核确认中',
    day: '天'
  },
  // 充值Class
  rechargeClass: {
    rechargeAmount: '充值金额',
    wechatPay: '微信支付',
    alipay: '支付宝支付',
    offlinePay: '银行转账',
    qrcode: '支付二维码',
    rechargeTips: '请将XXXX元，转账汇款至XXXX账号，账户名为XXXX，汇款完成后请联系客服，有任何问题请联系XXXX',
    tips1: '请将',
    tips2: '元',
    tips3: '转账汇款至',
    tips4: '账号',
    tips5: '账户名为',
    tips6: '汇款完成后请联系客服，有任何问题请联系',
    rechargeTips: '充值完成，等待确认中！',
    amountPaid: '请选择支付金额',
    paymentMethod: '请选择支付方式',
    level: '请选择会员等级',
    selectTips: '点击选择支付方式',
    selectVip: '点击选择会员等级',
    selectPaid: '点击选择支付金额',
    amountToast: '请选择支付金额',
    paymentToast: '请选择支付方式',
    levelToast: '请选择会员等级'
  },
  // 充值支付
  rechargePayClass: {
    transactionNo: '交易编号',
    transactionAmount: '交易金额',
    companyAccount: '公司账户',
    vevificationCode: '验证码',
    enterCode: '请输入验证码',
    send: '发送',
    confirmPay: '确认支付',
    balance: '余额'
  },
  // 账号管理Class
  managementClass: {
    userID: '平台用户ID',
    userName: '用户名',
    email: '邮箱',
    permissions: '权限',
    operation: '操作',
    administrator: '管理员（企业首席）',
    payPart: '支付员',
    update: '更新',
    delete: '删除',
    addAccount: '新建关联账号',
    updateAccount: '更新关联账号',
    deleteAccount: '删除关联账号',
    addID: '被添加用户ID',
    managementTips: '请输入被添用户ID,若被添加人未注册,请先让其注册',
    cancel: '取消',
    deleteTips: '确定要删除吗?',
    setPermissions: '设置权限',
    selectPermissions: '请选择角色权限',
    select: '请选择',
    sure: '确 定',
    selectsure: '确定'
  },
  // table相关
  tableClass: {
    time: '时间',
    transactionNo: '交易编号',
    transactionAmount: '交易金额(TEU COIN)',
    amountAccount: '账户金额(TEU COIN)',
    transactionType: '交易类型',
    tradeSources: '交易来源',
    amountPay: '实付金额（RMB）',
    usdAmountPay: '实付金额（USD）',
    trader: '交易人',
    accountID: '账户ID',
    accountName: '账户名',
    tel: '手机号',
    email: '邮箱',
    permissions: '权限',
    operation: '操作'
  },
  bankTransferClass: {
    companyAccount: '公司账户',
    remittanceAmount: '汇款金额',
    bankAccount: '开户行',
    account: '户头',
    contact: '联系人',
    contactNumber: '联系电话',
    contactWeChat: '联系微信',
    unit: '元',
    email: '',
    swift: '',
    whatapp: '',
    address: ''
  },
  commonPayClass: {
    orderNo: '订单编号',
    purpose: '交易类型',
    orderContent: '订单内容',
    paymentMethod: '支付方式',
    amount: '应付金额',
    pay: '立即支付',
    commitBtn: '提交',
    paymentCenter: '支付中心',
    currency: '美元',
    paypalTitle: 'Paypal支付',
    recharge: '充值'
  },
  commonPayResultClass: {
    statusSuccessTitle: '支付完成',
    statusFailTitle: '支付失败',
    resultSuccessTitle: '恭喜您，订单支付完成！',
    resultFailTitle: '很抱歉，订单支付失败！',
    orderNo: '订单编号',
    slipNo: '支付流水单编号',
    paymentMethod: '支付方式',
    amount: '支付金额',
    returnBack: '返回首页',
    returnInvoiceBack: '申请发票',
    currency: '美元',
    accountId: 'TEUCOIN账户',
    copyBtn: '复制',
    orderInfo: '订单信息',
    generativeCharity: '生成慈善证书',
    accountInfo: '收款账户',
    viewOrder: '查看订单',
    viewTicket: '查看我的票夹'
  },
  // 开具发票
  invoiceInfoClass: {
    companyName: '名称',
    dutyParagraph: '税号',
    address: '地址',
    phone: '电话',
    bankName: '开户行',
    bankCode: '账号',
    amount: '开具金额',
    issuedPhone: '推送电话',
    issuedEmail: '推送邮箱'
  },
  //系统提示
  systemPromptInformation:{
    title : '系统提示',
    content : '您的报名信息已提交，工作人员会尽快与您联系'
  }
}
